import { ChangeDetectionStrategy, Component, EventEmitter, Input, Output } from '@angular/core';
import { ProductListComponent } from '../product-list/product-list.component';
import { map, tap } from 'rxjs/operators';
import { Observable } from 'rxjs';
import { OrderformCartProductItem } from '../../fascades/product-list.fascade';

@Component({
  selector: 'orderform-product-list-mini',
  templateUrl: './product-list-mini.component.html',
  styleUrls: ['./product-list-mini.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ProductListMiniComponent extends ProductListComponent {
  @Output() readonly countProducts = new EventEmitter<number>();
  @Input() expressCheckoutMode = false;

  onlyActiveProductList$: Observable<OrderformCartProductItem[]> = this.productList$.pipe(
    map((productList) => {
      return productList.filter((product) => !!product.orderItem.quantity?.value);
    }),
    tap((products) => this.countProducts.emit(products.length))
  );
}
